<template>
  <div class="msgcenterWrapper">
    <TableToolTemp :toolListProps="{ toolTitle: '消息中心' }">
      <template #rightContent>
        <div class="readAll" v-if="integralInfo.msgNum">
          <span class="mallicin"></span>
          <span @click="readAll">全部标为已读</span>
        </div>
      </template>
    </TableToolTemp>
    <div class="msgWrapper">
      <div class="sidemenu">
        <span
          v-for="(item, index) in menuconfig"
          :key="index + item.name"
          :class="activeName == item.name ? 'on' : ''"
          @click="activeName = item.name"
        >
          <i>{{ item.label }} <el-badge v-if="item.msgNum" class="mark" :value="item.msgNum" /></i>
          <!-- <i class="num" v-if="item.msgNum">{{ item.msgNum }}</i> -->
        </span>
      </div>
      <div class="content">
        <component :is="activeName" @emitback='init'></component>
      </div>
    </div>
  </div>
</template>
<script>
import TableToolTemp from '@/components/layouts/TableToolTemp';
import systemLogs from './components/systemLogs.vue';
import claimLogs from './components/claimLogs.vue';
import healthServiceLogs from './components/healthServiceLogs.vue';
import { userPointInfo, msgCentersetAllRead } from '@/api/userCenter';
import { mapMutations } from 'vuex';
export default {
  components: {
    TableToolTemp,
    systemLogs,
    claimLogs,
    healthServiceLogs
  },
  watch: {
    '$store.state.user.bizTokenInfo'(newValue) {
      if (newValue && newValue.hasNewMsg == 1) {
        this.init();
      }
    },
  },
  data() {
    return {
      activeName: 'systemLogs',
      menuconfig: [
        {
          label: '系统通知',
          name: 'systemLogs',
          msgNum: 0,
        },
        {
            label:'理赔通知',
            name:'claimLogs',
            msgNum:0,
        },
        {
            label:'健康医疗通知',
            name:'healthServiceLogs',
            msgNum:0,
        }
      ],
      integralInfo: {},
    };
  },
  methods: {
    ...mapMutations(['user/SET_USER']),
    init() {

      userPointInfo({
        userId: this.$store.state.user.user.userId,
      }).then((res) => {
        if (res) {
          this.integralInfo = res;
          // if (res.msgNum && res.msgNum > 0) {
            this.menuconfig = this.menuconfig.map((item) => {
              item.msgNum = item.name == 'systemLogs' ? res.systemNum : (item.name == 'claimLogs'?res.claimNum:res.healthServiceNum);
              return item;
            });
          }
        // }
      });
    },
    readAll() {
      msgCentersetAllRead({
        userId: this.$store.state.user.user.userId,
      }).then((res) => {
        if (res && res.resp_code == 0) {
          this.menuconfig = this.menuconfig.map((item) => {
            item.msgNum = 0;
            return item;
          });
          this['user/SET_USER']({
            ...this.$store.state.user.user,
            hasMsg: 0,
          });
        }
      });
    },
  },
  created() {
    this.init();
  },
};
</script>
<style lang="less" scoped>
.readAll {
  margin-left: auto;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5788bb;
  cursor: pointer;
  .mallicin {
    display: inline-block;
    width: 17px;
    height: 14px;
    background: url(~@/assets/imgs/readall.png) no-repeat;
    background-size: 100% 100%;
    vertical-align: middle;
    margin-right: 6px;
  }
}
.msgWrapper {
  margin-top: 20px;
  border-top: 1px dotted #dcdce1;
  padding-top: 38px;
  display: flex;
  .sidemenu {
    background: #f6f6f6;
    display: flex;
    flex-direction: column;
    span {
      width: 180px;
      height: 50px;
      padding-left: 30px;
      cursor: pointer;
      display: flex;
      align-items: center;
      .num {
        display: inline-block;
        // padding: 2px;
        border-radius: 100%;
        width: 16px;
        height: 16px;
        text-align: center;
        line-height: 16px;
        background: rgba(255, 51, 51, 1);
        color: white;
        font-size: 12px;
        margin-left: 4px;
      }
      &.on {
        background: #fffcf6;
      }
    }
  }
  .content {
    flex: 1;
    margin-left: 20px;
    // height: 500px;
    // overflow-y: auto;
  }
}
</style>